import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CognitoService, IUser } from '../../core/services/cognito.service';
import { ValidationService } from '../../core/services/validation.service';
// import { OrganizationsService } from '../../shared/services/organizations.service';
// import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../core/auth/services/auth.service';

@Component({
    selector: 'auth-login-form',
    templateUrl: './auth-login-form.component.html',
    styleUrls: ['./auth-login-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLoginFormComponent {
    showPassword: boolean = false;
    user: IUser = {
        email: '',
        password: '',
    };

    constructor(
        protected router: Router,
        private cognitoService: CognitoService,
        private ngxService: NgxUiLoaderService,
        private validationService: ValidationService,
        // private organizationsService: OrganizationsService,
        // private translate: TranslateService,
        private _snackBar: MatSnackBar,
        private authService: AuthService,
    ) {}

    public async signIn(form: NgForm): Promise<void> {
        if (form.valid) {
            this.ngxService.start();
            const dataSignIn = await this.cognitoService.signIn(this.user).catch(__error => {
                this._snackBar.open('Invalid user or password, please try again or recover your password', 'x', {
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['notif-error'],
                    duration: 3000,
                });
                this.ngxService.stop();
            });
            if (dataSignIn) {
                if (dataSignIn.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    this._snackBar.open('Please check your mail for invitation', 'x', {
                        horizontalPosition: 'right',
                        verticalPosition: 'top',
                        panelClass: ['notif-error'],
                        duration: 3000,
                    });
                } else {
                    const accessToken = dataSignIn?.signInUserSession?.accessToken?.jwtToken;
                    const idToken = dataSignIn?.signInUserSession?.idToken?.jwtToken;
                    if (accessToken && idToken) {
                        this.authService.onAuthentication(accessToken, idToken);
                    }
                    this.router.navigate(['/dashboard']);
                }
                this.ngxService.stop();
            }
        }
    }

    validatorEmail: any = (c: any) => {
        return this.validationService.email(c);
    };

    validatorPassword: any = (c: any) => {
        return this.validationService.password(c);
    };

    public togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }
}
